// © Microsoft Corporation. All rights reserved.

/**
 * class defining perf trackers.
 */
export class PerfTracker {

    /** The perf tracker end time. */
    private endTime = -1;

    /** The perf tracker start time. */
    private startTime = -1;

    /**
     * Get perf tracker time duration
     */
    public getDuration(): number {
        let result = -1;
        if (this.startTime !== -1 && this.endTime !== -1) {
            result = this.endTime - this.startTime;
        }

        return result;
    }

    /**
     * get perf tracker end time
     */
    public getEnd(): number {
        return this.endTime;
    }

    /**
     * get perf tracker start time
     */
    public getStart(): number {
        return this.startTime;
    }

    /**
     * set perf tracker end time
     */
    public setEnd(): void {
        this.endTime = performance.now();
    }

    /**
     * set perf tracker start time
     */
    public setStart(): void {
        this.startTime = performance.now();
    }
}